import { defineComponent, reactive } from "vue";
import * as sandClock from "@/assets/lotties/sand-clock.json";
export default defineComponent({
  setup() {
    return { iconSand: reactive({ animationData: sandClock.default }) };
  },
});
